import { html, type TemplateResult } from "lit-html";
import { store, type AppState } from "../data/store";
import { formatRelative } from "../utils/time";
import { unreadTotal, activeBuyers } from "../utils/format";
import { iconSoundOn, iconSoundOff, iconBell } from "./icons";
import { requestPermission } from "../utils/notifications";

export function renderHeader(state: AppState): TemplateResult {
  const active = activeBuyers(state.buyers);
  const buyersCount = active.filter((b) => b.conv_status !== "paid").length;
  const unread = unreadTotal(active);
  const muted = state.notificationsMuted;
  return html`
    <header class="shell__header">
      <div>
        <span class="shell__brand">Festival Ops</span>
        <span class="shell__brand-sub">Operator dashboard</span>
      </div>
      <div class="shell__status">
        <span class="shell__pill">
          <span class="shell__pill-dot"></span>
          ${state.error ? "error" : state.loading ? "loading" : "live"}
        </span>
        ${unread > 0 ? html`
          <button class="shell__pill shell__pill--unread shell__pill--button"
                  title="Click to mark all ${unread} as read"
                  @click=${() => store.markAllRead()}>
            <span class="unread-badge unread-badge--inline">${unread}</span>
            unread · clear all
          </button>
        ` : ""}
        <span class="shell__pill">${buyersCount} buyers</span>
        <button class="shell__pill shell__pill--button shell__pill--mute"
                title=${muted ? "Notifications muted — click to unmute" : "Notifications on — click to mute"}
                aria-pressed=${muted ? "true" : "false"}
                @click=${() => store.toggleNotificationsMuted()}>
          ${muted ? iconSoundOff() : iconSoundOn()}
        </button>
        <span class="shell__pill">
          ${state.loadedAt ? `updated ${formatRelative(state.loadedAt)}` : "—"}
        </span>
      </div>
      ${renderNotifPrompt(state)}
    </header>
  `;
}

function renderNotifPrompt(state: AppState): TemplateResult {
  if (state.notificationPermission !== "default") return html``;
  if (state.notificationPromptDismissed) return html``;
  return html`
    <div class="shell__notif-prompt">
      <span class="shell__notif-prompt-icon">${iconBell()}</span>
      <span class="shell__notif-prompt-text">
        Get OS notifications when a new buyer messages you.
      </span>
      <button class="btn btn--primary btn--small" type="button"
              @click=${() => void requestPermission()}>Enable</button>
      <button class="btn btn--ghost btn--small" type="button"
              @click=${() => store.dismissNotificationPrompt()}>Not now</button>
    </div>
  `;
}
